<template>
    <BlogLayout v-bind="blogSharedData.getBlogLayoutProps()">
        <section class="max-w-3xl mx-auto px-6 pt-12 pb-20">
            <BlogPostHero :post="post" />

            <BlogPostCoverImage :post="post" />

            <BlogPostCoverAttribution
                v-if="post.hasCoverAttribution()"
                :post="post"
            />

            <article
                class="markdown-body mt-12"
                v-html="post.htmlContent"
            />

            <!-- <Author :appName="blogSharedData.appName" /> -->

            <div class="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
                <BlogPostNavigationLink
                    v-if="previousPost"
                    label="Previous"
                    :title="previousPost.title"
                    :url="previousPost.url"
                    :isTextAlignedRight="false"
                />

                <div v-else />

                <BlogPostNavigationLink
                    v-if="nextPost"
                    label="Next"
                    :title="nextPost.title"
                    :url="nextPost.url"
                    :isTextAlignedRight="true"
                />
            </div>
        </section>
    </BlogLayout>
</template>

<script setup lang="ts">
    import Author from '@/Marketing/Blog/Component/Author.vue'
    import BlogPostCoverAttribution from '@/Marketing/Blog/Component/BlogPostCoverAttribution.vue'
    import BlogPostCoverImage from '@/Marketing/Blog/Component/BlogPostCoverImage.vue'
    import BlogPostHero from '@/Marketing/Blog/Component/BlogPostHero.vue'
    import BlogPostNavigationLink from '@/Marketing/Blog/Component/BlogPostNavigationLink.vue'
    import BlogSharedData from '@/Marketing/Blog/Entity/BlogSharedData'
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'
    import BlogLayout from '@/Marketing/Blog/Shared/BlogLayout.vue'
    import type {
        CMSArticleRawData,
        BlogSharedDataRawData,
    } from '@/Shared/AutoGenerated/Main'

    interface BlogShowArticleProps {
        blogSharedDataRawData: BlogSharedDataRawData
        postRawData: CMSArticleRawData
        previousPostRawData: CMSArticleRawData | null
        nextPostRawData: CMSArticleRawData | null
    }

    const props = defineProps<BlogShowArticleProps>()

    const blogSharedData = BlogSharedData.hydrate(props.blogSharedDataRawData)
    const post = CMSArticle.hydrateSingle(props.postRawData)
    const previousPost = CMSArticle.hydrateSingleOrNull(
        props.previousPostRawData,
    )
    const nextPost = CMSArticle.hydrateSingleOrNull(props.nextPostRawData)
</script>
